export default {
  login: "ログインして続行してください...",
  password_rule: "* パスワードは大文字と小文字を区別し、6〜10文字である必要があります。",
  nickname_rule: "* 表示およびログイン用にニックネームを設定できます（6〜15文字のアルファベットまたは数字）。このニックネームは一度のみ設定できます。設定後の変更やキャンセルはできませんのでご注意ください。",
  change_password_succeed: "パスワードの変更に成功しました。",
  add_secondary_succeed: "ニックネームの設定に成功しました。",
  succeed: "操作が正常に完了しました！",
  failed: "操作に失敗しました！",
  no_information_available: "利用可能な情報はありません。",
  select_display_language: "お好みのデフォルト言語を選択してください。",
  select_odds_type: "お好みのデフォルトのオッズタイプ表示を選択してください。",
  select_page_type: "本日および早期市場ページの両方で表示するためのデフォルトページタイプを選択してください。",
  select_show_score_map: "ベットを行う際に自動的にスコアマップを表示するようにシステムを設定します。",
  select_default_event_sorting: "お好みのデフォルトのイベントソート表示を選択してください。",
  select_market_type: "お好みのマーケットを選択してください。",
  select_page_size: "お好みのページサイズを選択してください。",
  change_sports_menu_order: "スポーツをドラッグして、スポーツメニューの順序を変更してください。",
  view_outstanding_bets_in_bet_list: "未決のベットは処理に時間がかかる場合があります。最新の未決ベットを表示するには、ベットリストに移動してください。",
  time_display_in_gmt_plus_8: "上記の時間はGMT+8で表示されています。",
  select_default_stake: "システムを有効にして、カスタマイズされたステークおよび最後のベットステークを自動的に入力します。",
  bet_empty: "ベットスリップが空です。テーブルのオッズをクリックしてベットを選択してください。",
  no_event: "現在利用可能な試合やゲームはありません。他のスポーツイベントやゲームを訪れるか、後で戻ってください。",
  no_bets: "実行中のベットはありません",
  no_waiting: "待機中のベットはありません",
  no_void: "無効なベットはありません",
  confirmation: "このベットを確定しますか？",
  olderversion: "古いバージョンが検出されました。更新するにはOKをクリックするか、Ctrl-F5を押してください。",
  gmt8: "上記の時間はGMT+8で表示されています。",
  confirm_bet: "ベットを確認しますか？",
  match_not_started: "試合が開始されていません",
  odds_changed: "オッズが変更されました",
  ldiff_changed: "割合が変更されました",
  to: "から",
  dnsta: "これを再表示しないでください。",
  login2: "ログインしてゲームにアクセスするには、最初にアカウントを登録する必要があります。すでにアカウントをお持ちの場合は、ログインを続けてください。",
  no_video: "%%にビデオが見つかりません",
  days: "日",
  hours: "時間",
  mins: "分",
  secs: "秒",
  room_full: "この部屋は満員です",
  room_joined: "この部屋に参加しました",
  no_room: "利用可能な部屋がありません。他のオプションを選択して再検索するか、後で戻ってください。",
  are_you_sure: "この操作を続行してよろしいですか？",
  no_matches: "現在利用可能な試合やゲームはありません。",
  pin_code: "例：1234566",
  accept_terms: "チェックを入れることで、上記の利用規約を読んで理解し、同意したことを確認します。",
  accept_required: "続行する前に、上記の利用規約を読んで理解し、同意してください。",
  my_room: "マイルーム",
  not_winning_prize_in_this_tournament: "このトーナメントで賞を獲得していません",
  you_did_not_join_this_room: "この部屋に参加していません",
  room_password_rule: "* PINコードは6桁の数字である必要があります。",
  jan: "1月",
  feb: "2月",
  mar: "3月",
  apr: "4月",
  may: "5月",
  jun: "6月",
  jul: "7月",
  aug: "8月",
  sep: "9月",
  oct: "10月",
  nov: "11月",
  dec: "12月",
  must_accept_better_odds: "デフォルトでは、ベットを配置すると自動的により良いオッズを受け入れます。詳細は利用規約をご参照ください。",
  maintenance_notice: "現在、システムメンテナンスを行っています。後でもう一度お試しください。",
  deduct_confirm: "これによりゲームが開始され、クレジットが差し引かれます。<br />続行してよろしいですか？",
  no_more_bets: "これ以上のベットはありません。",
  over_max_match: "このリーグの試合数は選択可能な試合数の最大値を超えています。<br />リーグを拡大して、希望の試合を選択してください。",
  button_skip: "ツアーをスキップ",
  button_previous: "前へ",
  button_next: "次へ",
  button_stop: "終了",
  button_continue: "続ける",
  tour_content_1: "<h6>WBETトーナメントへようこそ</h6><p>私たちのサイトサポーターのためだけにエキサイティングな新しいトーナメントを発表できることを嬉しく思います。</p>",
  tour_content_2: "<h6>パブリックルーム</h6><p>メンバーは通常、参加費を支払ってお互いに競技的なゲームプレイを行います。</p>",
  tour_content_3: "<h6>プライベートルーム</h6><p>メンバーは、招待ピンを使用して友人と遊ぶためにルームを開くことができます。</p>",
  tour_content_4: "<h6>パブリックフリールーム</h6><p>さまざまな組織が特別なイベント中にメンバーのために主催し、無料で参加できるルームです。</p>",
  tour_content_5: "<h6>参加可能なプレイヤーと料金</h6><p>プレイヤー: ルームの収容人数。</p><p>参加費: ルームのオファーに基づく（口座保有者の通貨）。",
  tour_content_6: "<h6>ルーム詳細</h6><p>ここをクリックしてルームの統計情報をプレビューし、ルームに参加します。</p>",
  tour_content_7: "<h6>プール詳細</h6><p>優勝者のための総プール賞金と検索用のユニークなルームID。</p>",
  tour_content_8: "<h6>ルーム開始詳細</h6><p>ルームの状態と最後の参加時間を表示します。",
  tour_content_9: "<h6>プライベートルームの作成</h6><p>プライベートルームを作成し、友人をピンで招待して参加します。</p>",
  tour_content_10: "<h6>ポイントランキング</h6><p>この機能は、プレイヤーのポイントを表示し、結果を追跡するためのものです。</p>",
  banner1_h1: "スポーツベッティング",
  banner1_p: "90以上のスポーツと数千のライブマッチが揃った総合的な選択肢で、アドレナリンの興奮が止まらない。",
  banner2_h1: "ライブカジノ",
  banner2_p: "豊かで没入感のあるカジノゲーム体験を楽しみながら、豪華なスイートのいずれかで勝利を手に入れましょう。",
  banner3_h1: "スロットゲーム",
  banner3_p: "目の届く限りの広範なゲームの選択肢。今すぐそれを直接体験してください。",
  banner4_h1: "E-ファイティング",
  banner4_p: "お気に入りのキャラクターを集め、競技的な戦闘に挑み、戦場に足を踏み入れて戦いを感じましょう！",
  banner5_h1: "トーナメント",
  banner5_p: "スキル、戦略、情熱の究極のディスプレイの準備をしましょう。市内各地のチームが毎年恒例のサッカートーナメントで戦います。",
};
